<template>
    <sui-table-body>
        <sui-table-row>
            <sui-table-header-cell>
                Port-Status
            </sui-table-header-cell>
            <sui-table-cell>
                <span v-if="apiResponse">{{toUserFriendlyTimestamp(apiResponse.headers.date, true, false)}}</span> 
                <sui-button v-if="includeReloadBtn" size="mini" @click.prevent="getNexelStatus" style="float: right"><i class="fas fa-sync" v-bind:class="{'fa-spin': statusLoading}"></i></sui-button>
            </sui-table-cell>
        </sui-table-row>
        <template v-if="apiResponse">
            <sui-table-row>
                <sui-table-cell>NTP link</sui-table-cell>
                <sui-table-cell :class="apiResponse.operationalStatus=='up' ? 'signalInRange' : 'signalOutOfRange'">{{apiResponse.operationalStatus}}</sui-table-cell>
            </sui-table-row>
            <sui-table-row>
                <sui-table-cell>ASR link</sui-table-cell>
                <sui-table-cell :class="apiResponse.administrativeStatus=='up' ? 'signalInRange' : 'signalOutOfRange'">{{apiResponse.administrativeStatus}}</sui-table-cell>
            </sui-table-row>
            <sui-table-row>
                <sui-table-cell>Link speed</sui-table-cell>
                <sui-table-cell>{{formatLinkSpeed(apiResponse.linkSpeedDownstream)}} / {{formatLinkSpeed(apiResponse.linkSpeedUpstream)}}</sui-table-cell>
            </sui-table-row>
            <sui-table-row v-if="typeof apiResponse.inputErrorCount != 'undefined' || typeof apiResponse.outputErrorCount != 'undefined'">
                <sui-table-cell>Error Count (input/output)</sui-table-cell>
                <sui-table-cell>{{ String(apiResponse.inputErrorCount) }}/{{ String(apiResponse.outputErrorCount) }}</sui-table-cell>
            </sui-table-row>
            <sui-table-row v-if="apiResponse.opticalSignalPower && apiResponse.opticalSignalPower.access">
                <sui-table-cell>Access optical signal power (rx/tx)</sui-table-cell>
                <sui-table-cell>
                    <span v-if="apiResponse.opticalSignalPower.access.receive" :class="apiResponse.opticalSignalPower.access.receive.inRange ? 'signalInRange' : 'signalOutOfRange'">{{ apiResponse.opticalSignalPower.access.receive.value || 'null' }}</span>
                    <span v-else>null</span>
                    /
                    <span v-if="apiResponse.opticalSignalPower.access.transmit" :class="apiResponse.opticalSignalPower.access.transmit.inRange ? 'signalInRange' : 'signalOutOfRange'">{{ apiResponse.opticalSignalPower.access.transmit.value || 'null' }}</span>
                    <span v-else>null</span>
                </sui-table-cell>
            </sui-table-row>
            <sui-table-row v-if="apiResponse.opticalSignalPower && apiResponse.opticalSignalPower.ntp">
                <sui-table-cell>NTP optical signal power (rx/tx)</sui-table-cell>
                <sui-table-cell>
                    <span v-if="apiResponse.opticalSignalPower.ntp.receive" :class="apiResponse.opticalSignalPower.ntp.receive.inRange ? 'signalInRange' : 'signalOutOfRange'">{{ apiResponse.opticalSignalPower.ntp.receive.value || 'null' }}</span>
                    <span v-else>null</span>
                    /
                    <span v-if="apiResponse.opticalSignalPower.ntp.transmit" :class="apiResponse.opticalSignalPower.ntp.transmit.inRange ? 'signalInRange' : 'signalOutOfRange'">{{ apiResponse.opticalSignalPower.ntp.transmit.value || 'null' }}</span>
                    <span v-else>null</span>
                </sui-table-cell>
            </sui-table-row>
        </template>
        <template v-if="apiError && apiError.errorObject">
            <sui-table-row>
                <sui-table-cell colspan="2" style="color: red;">
                    Fejl ved hentning af data: {{apiError.errorObject.message || 'Ukendt fejl'}}
                </sui-table-cell>
            </sui-table-row>
            <!-- <sui-table-row v-for="key in Object.keys(apiError.errorObject)" :key="key">
                <sui-table-cell>{{ key }}</sui-table-cell>
                <sui-table-cell>{{apiError.errorObject[key]}}</sui-table-cell>
            </sui-table-row> -->
            <sui-table-row> <!-- Error code explanations -->
                <sui-table-cell v-if="apiError.errorObject.status == '403'" colspan="2">
                    Fejl 403 betyder at vores API-nøgle ikke har tilladelse til at hente Nexel-status for denne installation.
                </sui-table-cell>
                <sui-table-cell v-else-if="apiError.errorObject.status == '404'" colspan="2">
                    På PON-installationer kan fejl 404 betyde at der ikke er registreret en fiberboks på installationen, eller at fiberboksen aldrig har været online.<br><br>
                    På PtP-installationer betyder fejl 404 typisk at ASR'en i teknikhuset ikke er konfigureret til at rapportere Nexel-status. (Data harvest ikke aktiveret)
                </sui-table-cell> 
                <sui-table-cell v-else-if="apiError.errorObject.status == '500'" colspan="2">
                    Fejl 500 betyder at der er en intern serverfejl hos PilotBI/VirkPlan. Prøv igen senere.
                </sui-table-cell>
            </sui-table-row>
        </template>
    </sui-table-body>
</template>

<script>
import { Mixin } from '../../lib/Mixins/mixin'
import { DateMixin } from '../../lib/Mixins/dateMixin'
import { DataAPI } from '../../lib/DataAPI'
import EventBus from '../../EventBus'

export default {
    mixins: [Mixin, DateMixin, DataAPI],

    components: {
        // TableLoader,
    },

    props: {
        instLabel: String,
        includeReloadBtn: {
            type: Boolean,
            default: true
        },
    },

    data(){
        return {
            statusLoading: false,
            apiResponse: null,
            apiError: null,
        }
    },

    methods: {
        async getNexelStatus() {
            EventBus.$emit('function-activity', {functionName: 'NexelStatus_getNexelStatus', isActive: true})
            this.apiResponse = null
            this.apiError = null
            EventBus.$emit('retrieved-nexel-status', {data: 'Henter status...', loading: true})
            if (!this.instLabel) {
                EventBus.$emit('retrieved-nexel-status', {data: 'Intet installations-nr', loading: false})
                EventBus.$emit('function-activity', {functionName: 'NexelStatus_getNexelStatus', isActive: false})
                return null
            }
            this.statusLoading = true
            try {
                this.apiResponse = await this.dataGetNexelStatus(this.instLabel)
                EventBus.$emit('retrieved-nexel-status', {data: this.apiResponse.id, loading: false})
                this.statusLoading = false
            } catch (error) {
                EventBus.$emit('retrieved-nexel-status', {data: 'Kunne ikke hente data!', loading: false})
                console.error(error)
                this.apiError = error
                this.statusLoading = false
            }
            EventBus.$emit('function-activity', {functionName: 'NexelStatus_getNexelStatus', isActive: false})
            return this.apiResponse
        },
    },

    mounted() {
        EventBus.$on('reload-nexel-status-click', () => {this.getNexelStatus()})
    },

    beforeDestroy() {
        EventBus.$off('reload-nexel-status-click')
    },

    watch: {
        instLabel: {
            immediate: true,
            handler() {
                this.getNexelStatus()
            }
        }
    }
}
</script>
<style scoped>
    .signalInRange{
        color: green;
        font-weight: bold;
    }
    .signalOutOfRange{
        color: red;
        font-weight: bold;
    }
</style>